import Slider, { Settings } from "react-slick";
// import { IoCodeSlash } from "react-icons/io5";
// import guyWithLaptiop from "../Images/guy_with_laptop.png";
import penSvg from "../Images/pen.svg";
import discover from "../Images/discover.svg";
import share from "../Images/share.svg";
import verify from "../Images/verify.svg";
// import { FiDatabase } from "react-icons/fi";
// import cyberExperience from "../Images/cyberpack_experience.png";
// import cbp01 from "../Images/development-frameworks.svg";
// import cbp02 from "../Images/it-professionals.svg";
// import cbp03 from "../Images/projects-completed.svg";
import { MarqueeComponent } from "../Components/MarqueeComponent";
// import { OurProject } from "../Components/OurProject";
// import testLeft from "../Images/testimonial.png";
// import { useNavigate } from "react-router-dom";
// import * as routes from "../Data/Routes";
import Typewriter from "../Components/Typewritter";
import productDesign from "../Images/productDesign.png";
import { useEffect } from "react";
import { BiSolidRightArrow } from "react-icons/bi";
import { ScrollToSection } from "../HelperFunctions/Helpers";
import { ProjectEnquiry } from "./ProjectEnquiry";
import { OurWork } from "./OurWork";
// import ProcessFlow from "./ProcessFlow";

export const ProductDesign = () => {
  // const navigate = useNavigate();

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: smooth scrolling animation
      });
    };
    handleScrollToTop();
  }, []);

  const settings2: Settings = {
    rtl: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="flex flex-col pt-[60px]">
      <section
        id="home"
        className="bg-[#1B1B22] font-italianax h-screen flex items-center justify-center"
      >
        <div className="h-fit flex flex-col lg:flex-row items-center w-[calc(100%-5vw)] lg:w-[calc(100%-8vw)] xl:w-[calc(100%-14vw)] mx-auto mt-10">
          <div className="lg:w-[45%] mt-20 lg:mt-0">
            <div className="text-[20px] md:text-[35px] lg:text-[40px] xl:text-[45px] text-[#0FB8F9]  font-semibold leading-[100%] mt-8 mb-2 text-center lg:text-left">
              Smart <span className="font-bold text-[#F5F5F5]">Design </span>
              for
              <br className="" />
              Bold{" "}
              <span className="font-bold text-[#F5F5F5]">
                <Typewriter
                  toRotate={["Ideas.", "Code."]}
                  typingSpeed={500}
                  pauseBeforeDelete={10000}
                />
              </span>
            </div>

            <div className="text-[#FAFAFA] text-base md:text-2xl leading-[150%] tracking-[0%] my-10 font-normal text-center lg:text-left mx-auto lg:mx-0">
              We help startups and brands turn vision into visuals.
            </div>

            <div className="w-fit mx-auto lg:mx-0">
              <button
                className="bg-[#0FB8F9] text-[#F5F5F5] text-xl px-6 py-2 rounded-[30px] mt-5 w-[244px]"
                onClick={() => {
                  ScrollToSection("project-enquiries");
                }}
              >
                Get Started
              </button>
            </div>
          </div>

          <div className="w-[75vw] h-[75vw] md:w-[55vw] md:h-[55vw] lg:size-[377px]  lg:ml-auto my-10">
            <img src={productDesign} alt="" className="w-full h-full" />
          </div>
        </div>
      </section>

      <section className="bg-[#09A7E4] h-[500px] md:h-[720px] flex items-center justify-center flex-col font-manropex">
        <div className="text-xl md:text-[40px] text-[#F5F5F5] leading-[150%] tracking-[0%] font-medium text-center w-[90vw] md:w-[70vw] lg:w-[50vw]">
          We design digital products that people love to use <br />
          Beautiful | Intuitive | Strategic
        </div>
        <div className="text-white text-sm md:text-[25px] leading-[170%] tracking-[0%] font-normal text-center w-[90vw] md:w-[80vw] mt-16">
          We specialize in crafting world-class UI/UX and product design
          experiences for startups, scale-ups, and enterprises ready to lead in
          the digital space. Whether you're building a product from scratch or
          looking to improve what already exists, we turn complex challenges
          into elegant, user-centered solutions that drive results.
        </div>
      </section>

      <section
        id="our-services"
        className="lg:h-fit bg-[#1B1B22] px-[5vw] xl:px-[5vw] flex items-center justify-center font-manropex"
      >
        <div className="w-fit grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px] py-[5vh] lg:py-0 mx-auto mt-0 lg:mt-36 mb-10">
          <div className="">
            <div className="h-[82px] flex items-center mt-20">
              <hr className=" rotate-180 bg-[#09A7E4] h-[42px] w-[6px] rounded-[50px]" />{" "}
              <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
                <span className="font-medium">WHAT</span>
                <br />
                <span className="font-bold">We Do Best</span>
              </div>
            </div>
            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%] lg:w-[276px]">
              We turn ideas into powerful digital products, built to perform,
              scale, and grow with your business.
            </div>
          </div>

          <div className="h-[300px] md:h-[391px] p-[25px] w-[90vw] md:w-[40vw] lg:w-[30vw] xl:w-[367px] rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
            <div className="flex items-center">
              <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img
                  src={penSvg}
                  alt="pen icon"
                  className="w-[30px] h-[30px]"
                />
              </div>

              <div className="font-semibold text-xl xl:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
                Product design
              </div>
            </div>

            <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%]">
              From ideation to high-fidelity prototypes, we design digital
              products that are not only functional but delightful to use. Our
              team blends creativity with strategy to deliver designs that meet
              business goals and exceed user expectations.
            </div>
          </div>

          <div className="h-[300px] md:h-[391px] p-[25px] w-[90vw] md:w-[40vw] lg:w-[30vw] xl:w-[367px] rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
            <div className="flex items-center">
              <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                {/* <IoCodeSlash className="text-[30px] text-white" /> */}
                <img
                  src={penSvg}
                  alt="pen icon"
                  className="w-[30px] h-[30px]"
                />
              </div>

              <div className="font-semibold text-xl xl:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
                UI/UX Design
              </div>
            </div>

            <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%]">
              We create interfaces that are visually stunning and easy to
              navigate. With a sharp eye for detail and a strong understanding
              of design systems, accessibility, and interaction design, we
              ensure every click, scroll, and tap feels effortless.
            </div>
          </div>

          <div className="h-[300px] md:h-[391px] p-[25px] w-[90vw] md:w-[40vw] lg:w-[30vw] xl:w-[367px] rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
            <div className="flex items-center">
              <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img
                  src={penSvg}
                  alt="pen icon"
                  className="w-[30px] h-[30px]"
                />
              </div>

              <div className="font-semibold text-xl lg:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
                Design Systems
              </div>
            </div>

            <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%]">
              Scalability starts with consistency. We build robust, flexible
              design systems that help your development teams move faster and
              maintain brand cohesion across every touchpoint.
            </div>
          </div>

          <div className="h-[300px] md:h-[391px] p-[25px] w-[90vw] md:w-[40vw] lg:w-[30vw] xl:w-[367px] rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
            <div className="flex items-center">
              <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img
                  src={penSvg}
                  alt="pen icon"
                  className="w-[30px] h-[30px]"
                />
              </div>

              <div className="font-semibold text-xl xl:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
                Web & Mobile Experiences
              </div>
            </div>

            <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%]">
              From responsive websites to native mobile apps, we design across
              platforms with a deep understanding of platform-specific best
              practices for iOS, Android, and the modern web.
            </div>
          </div>

          <div className="h-[300px] md:h-[391px] p-[25px] w-[90vw] md:w-[40vw] lg:w-[30vw] xl:w-[367px] rounded-[30px] bg-[#2A2A2F] flex flex-col justify-center">
            <div className="flex items-center">
              <div className="size-[55px] md:size-[67.76px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img
                  src={penSvg}
                  alt="pen icon"
                  className="w-[30px] h-[30px]"
                />
              </div>

              <div className="font-semibold text-xl xl:text-[25px] leading-[100%] tracking-[0%] text-[#F0FBFF] ml-5">
                Prototyping & User Testing
              </div>
            </div>

            <hr className="border-[#3D3D41] border-[1px] mt-5 mb-3" />

            <div className="text-[#F0FBFF] text-sm md:text-base xl:text-[20px] font-normal leading-[130%] tracking-[0%]">
              Before anything goes live, we bring your ideas to life with
              interactive prototypes and validate them with real users—ensuring
              what we build is what your users need.
            </div>
          </div>
        </div>
      </section>

      <section
        id="our-process"
        className="h-fit bg-[#1B1B22] flex flex-col items-center font-manropex"
      >
        <div className="mx-auto w-[95vw] md:w-[80vw]">
          <div className="h-[122px] flex items-center mt-7">
            <hr className=" rotate-180 bg-[#09A7E4] h-[32px] w-[6px] rounded-[50px]" />{" "}
            <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
              <span className="font-medium text-[20px]">OUR</span>
              <br />
              <span className="font-bold text-[30px]">Process</span>
            </div>
          </div>

          <div className="w-fit border-2m grid grid-cols-2 lg:grid-cols-4 gap-y-[20px] justify-center items-center py-[5vh] lg:py-0 mx-auto mt-0 lg:mt-36 mb-10">
            <div className="flex items-center justify-center">
              <div className="size-[140px] md:size-[196px] rounded-[50%] bg-[#2A2A2F] relative flex items-center justify-center text-[25px] text-[#F0FBFF] font-bold leading-[100%] tracking-[0%]">
                <div className="border-t-[10px] border-r-[10px] border-[#09A7E4] w-[75px] md:w-[113px] h-[75px] md:h-[113px] absolute left-[80px] md:left-[105px] bottom-[80px] md:bottom-[105px] rounded-tr-[100%]"></div>
                Discover
              </div>
            </div>
            <div className="text-sm md:text-xl leading-[130%] tracking-[0%] text-[#F0FBFF] font-normal">
              Wireframes, user journeys, and prototypes bring ideas to life.
              Every pixel has a purpose, and every interaction is intentional.
            </div>

            <div className="relative lg:hidden">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={discover} alt="pen icon" className="size-[24px]" />
              </div>
              <BiSolidRightArrow className="text-[29px] text-[#2A2A2F] absolute top-[39%] right-[-1.5%]" />
            </div>
            <div className="relative lg:hidden">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={penSvg} alt="pen icon" className="size-[24px]" />
              </div>
            </div>

            <div className="flex items-center justify-center">
              <div className="size-[140px] md:size-[196px] rounded-[50%] bg-[#2A2A2F] relative flex items-center justify-center text-[25px] text-[#F0FBFF] font-bold leading-[100%] tracking-[0%]">
                <div className="border-t-[10px] border-r-[10px] border-[#09A7E4] w-[75px] md:w-[113px] h-[75px] md:h-[113px] absolute left-[80px] md:left-[105px] bottom-[80px] md:bottom-[105px] rounded-tr-[100%]"></div>
                Validate
              </div>
            </div>
            <div className="text-sm md:text-xl leading-[130%] tracking-[0%] text-[#F0FBFF] font-normal">
              We package everything into a developer-friendly handoff with clear
              documentation, scalable design systems, and production-ready
              assets.
            </div>

            <div className="relative hidden lg:block">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={discover} alt="pen icon" className="size-[24px]" />
              </div>
              <BiSolidRightArrow className="text-[29px] text-[#2A2A2F] absolute top-[39%] right-[-1.5%]" />
            </div>
            <div className="relative hidden lg:block">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={penSvg} alt="pen icon" className="size-[24px]" />
              </div>
              <BiSolidRightArrow className="text-[29px] text-[#2A2A2F] absolute top-[39%] right-[-1.5%]" />
            </div>
            <div className="relative">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={share} alt="pen icon" className="size-[24px]" />
              </div>
              <BiSolidRightArrow className="text-[29px] text-[#2A2A2F] absolute top-[39%] right-[-1.5%]" />
            </div>
            <div className="relative">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={verify} alt="pen icon" className="size-[24px]" />
              </div>
            </div>

            <div className="text-sm md:text-xl leading-[130%] tracking-[0%] text-[#F0FBFF] font-normal">
              We dive deep into your users, business, and product vision.
              Through stakeholder interviews, competitive analysis, and UX
              audits, we build a clear roadmap.
            </div>
            <div className="flex items-center justify-center">
              <div className="size-[140px] md:size-[196px] rounded-[50%] bg-[#2A2A2F] relative flex items-center justify-center text-[25px] text-[#F0FBFF] font-bold leading-[100%] tracking-[0%]">
                <div className="border-b-[10px] border-r-[10px] border-[#09A7E4] w-[75px] md:w-[113px] h-[75px] md:h-[113px] absolute left-[80px] md:left-[105px] top-[80px] md:top-[105px] rounded-br-[100%]"></div>
                Design
              </div>
            </div>

            <div className="relative lg:hidden">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={discover} alt="pen icon" className="size-[24px]" />
              </div>
              <BiSolidRightArrow className="text-[29px] text-[#2A2A2F] absolute top-[39%] right-[-1.5%]" />
            </div>
            <div className="relative lg:hidden">
              <hr className="rotate-180 bg-[#565658] h-[131px] w-[1px] rounded-[50px] mx-auto" />
              <hr className=" border-[#565658] h-[1px] w-full rounded-[50px] left-auto absolute top-[50%]" />
              <div className="absolute left-[42%] top-[30%] size-[40px] md:size-[51px] bg-[#09A7E4] rounded-full flex items-center justify-center">
                <img src={penSvg} alt="pen icon" className="size-[24px]" />
              </div>
            </div>

            <div className="text-sm md:text-xl leading-[130%] tracking-[0%] text-[#F0FBFF] font-normal">
              Real users. Real feedback. We test designs with your audience to
              uncover insights, reduce risk, and ensure clarity.
            </div>
            <div className="flex items-center justify-center">
              <div className="size-[140px] md:size-[196px] rounded-[50%] bg-[#2A2A2F] relative flex items-center justify-center text-[25px] text-[#F0FBFF] font-bold leading-[100%] tracking-[0%]">
                <div className="border-b-[10px] border-r-[10px] border-[#09A7E4] w-[75px] md:w-[113px] h-[75px] md:h-[113px] absolute left-[80px] md:left-[105px] top-[80px] md:top-[105px] rounded-br-[100%]"></div>
                Deliver
              </div>
            </div>
          </div>
        </div>
      </section>

      <OurWork />

      <div className="h-[720px] bg-[#1B1B22] flex flex-col items-center">
        <div className="w-full h-full flex flex-col items-center justify-center relative overflow-hidden lg:testimonial-bg">
          <div className="w-[90%] md:w-[60%] flex flex-col mx-auto">
            <div className="text-[#09A7E4] leading-[100%] tracking-[0%] text-[30px] text-center mt-5 mb-3">
              OUR <span className="font-bold">TESTIMONIALS</span>
            </div>
            <Slider {...settings2}>
              {[
                {
                  description:
                    "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
                  name: "Joseph Thomas",
                  company: "Chairman, StormX",
                },
                {
                  description:
                    "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
                  name: "Joseph Thomas",
                  company: "Chairman, StormX",
                },
                {
                  description:
                    "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
                  name: "Joseph Thomas",
                  company: "Chairman, StormX",
                },
                {
                  description:
                    "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
                  name: "Joseph Thomas",
                  company: "Chairman, StormX",
                },
              ].map((dt, index) => (
                <div
                  key={index}
                  className="h-[450px] flex flex-col items-center justify-center z-[5] text-[#FFFFFF]"
                >
                  <div className="my-[34px] h-[374px] rounded-tl-[50px] rounded-br-[50px] bg-[#2A2A2F] relative">
                    <div className="absolute top-[-14px] md:top-[-20px] left-[40px] md:left-[75px] flex gap-x-3">
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[30deg]" />
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[30deg]" />
                    </div>
                    <div className="absolute bottom-[-14px] md:bottom-[-20px] right-[40px] md:right-[75px] flex gap-x-3">
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[-30deg]" />
                      <hr className="w-[18px] md:w-[25px] h-[35px] md:h-[51px] bg-[#09A7E4] skew-x-[-30deg]" />
                    </div>
                    <div className="py-[40px] h-full flex flex-col">
                      <div className="w-[90%] md:w-[60%] mt-5 mx-auto text-[#FFFFFF] leading-[36px] tracking-[0%] text-xl font-normal text-center">
                        {dt.description}
                      </div>
                      <div className="text-[#FFFFFF] font-medium leading-[36px] tracking-[0%] text-xl text-center mt-8 md:mt-16">
                        {dt.name}
                      </div>
                      <div className="text-[#FFFFFF] font-normal leading-[36px] tracking-[0%] text-base text-center">
                        {dt.company}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <div className="h-[320px] px-[5vw] bg-[#1B1B22] flex flex-col items-center justify-center">
        <div className="text-[#09A7E4] leading-[100%] tracking-[0%] text-[30px] text-center w-fit mb-5">
          OUR <span className="font-bold">CLIENTS</span>
        </div>
        <MarqueeComponent />
      </div>

      <ProjectEnquiry />
    </div>
  );
};
